export default "/shipped.9ee7b722-d3b594.svg?svgr";